module.exports = __webpack_public_path__ + "img/on_drum_bold.59084a4b.png";